import React from 'react'
import PropTypes from 'prop-types'
import StyledBaseModal from './Modal.styles'

const Modal = props => {
  const { children, className, dataTestId, isModalOpen, modalClose } = props
  return (
    <StyledBaseModal
      className={className}
      dataTestId={dataTestId}
      isModalOpen={isModalOpen}
      modalClose={modalClose}
    >
      {children}
    </StyledBaseModal>
  )
}

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  className: PropTypes.string,
  dataTestId: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool,
  modalClose: PropTypes.func,
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.jsx